import { passwordValidationForSensitiveData} from "@/api/usuario"
import { useState } from "react"

export function useCheckPassword() {
  const [status, setStatus] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  const checkPasswordFunction = async (userEmail: string, password: string) => {
      const res = await passwordValidationForSensitiveData(userEmail, password)
      if (res.success) {
         setStatus(true)
         setError(null)
      } else {
         setStatus(false)
         setError("Contraseña incorrecta")
      }
  }

  return { status, error, checkPasswordFunction }
}